export default __webpack_public_path__ + "static/mobile-push-69940b38e5f6d0cfde248fba54937973.png";